import { AlertSeverityEnum } from "@/shared/interfaces";
import SaveActivacionCorporativoInstallPendingOT from "../../shared/component/SaveActivacionCorporativoInstallPendingOT";
import { useEffect } from "react";
import { EstadosActivacionInstallOTEnumChoice, ROUTER_PATHS, useCheckPermissions, useLoaders } from "@/shared";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useUiStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { useGetOrdenServicioCorporativoById } from "@/shared/actions/erp/tecnico/orden_servicio_corporativo";

export default function UpdateInstalacionCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);
  const returnUrlActivacionInstallOTPage =
    ROUTER_PATHS.operaciones.tecnicosInstalacionCorpNav;

  const navigate = useNavigate();

  const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenServicioCorporativoById(id!);
  useLoaders(isLoading || isRefetching);

  // validate state
  useEffect(() => {
    if (!data?.data?.id_orden_servicio_corporativo) return;
    if (
      data?.data?.estado_activacion !==
      EstadosActivacionInstallOTEnumChoice.EN_ESPERA
    ) {
      setAlert(
        true,
        'La orden de trabajo no tiene el estado correcto',
        AlertSeverityEnum.error
      );
      navigate(returnUrlActivacionInstallOTPage);
    }
  }, [data?.data?.id_orden_servicio_corporativo]);

  // se comenta el isRefetching x el invalidateQuery en form
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_orden_servicio_corporativo)
    return <Navigate to={returnUrlActivacionInstallOTPage} />;

  return (
    <SaveActivacionCorporativoInstallPendingOT
      ordenTrabajo={data.data}
      titlePage="Activación de Instalación Corporativo"
    />
  )

}